import HTTP from '.';
import LocalizationServiceMock from './mocks/LocalizationService.mock';
import config from '@/config';

export default class LocalizationService {
  static getCountriesWithProvince() {
    if (config.ENV.MOCK === true) {
      return LocalizationServiceMock.getCountriesWithProvince();
    }

    return HTTP.get('/api/countries/withProvinces');
  }
}
